"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useTracker = void 0;
const react_1 = require("react");
const react_router_dom_1 = require("react-router-dom");
const gtm_1 = require("utils/gtm");
let firstTime = true;
const useTracker = () => {
    const location = (0, react_router_dom_1.useLocation)();
    const pagePath = location.pathname + location.search;
    (0, react_1.useEffect)(() => {
        if (firstTime) {
            firstTime = false;
            return;
        }
        (0, gtm_1.pushGtm)({
            event: "page_view",
            pagePath,
        });
    }, [pagePath]);
};
exports.useTracker = useTracker;
